import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { PlusButton } from 'src/components/common/PlusButton/PlusButton';
import { SearchPanel } from 'src/components/SearchPanel/SearchPanel';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import { LeadsFilter, LeadsStore } from 'src/stores/LeadsStore/LeadsStore';
import { UserStore } from 'src/stores/UserStore/UserStore';
import { FormHelper } from 'src/utils/FormHelper';
import styled from 'styled-components';

export const LeadsPageHeaderPanel = observer(() => {
    const { t } = useTranslation();

    return (
        <StyledHeaderWrapper>
            <SearchPanel
                inputSearchFormName={formNames.getPath('filterSearch')}
                store={store}
                inputSearchPlaceholder={t(
                    'Page.Leads.Filter.Search.Placeholder',
                )}
            />
            {UserStore.can.manage.leads && (
                <Tooltip
                    title={t('Page.Leads.AsideHeader.CreateNewItem.Tooltip')}
                >
                    <PlusButton
                        onClick={() => {
                            const createLink = EntityLinks.leads.create?.();
                            createLink && Router.navigate(createLink);
                        }}
                        data-testid="header-panel-create-btn"
                    />
                </Tooltip>
            )}
        </StyledHeaderWrapper>
    );
});

const store = LeadsStore;
const formNames = FormHelper.createNameProvider<LeadsFilter>();

const StyledHeaderWrapper = styled.header`
    position: relative;
    display: grid;
    grid-template-columns: 1fr auto;
`;
